<template>
    <v-sheet class="sideInfo pl-4 pr-4 pt-4 d-flex flex-column">
        <span class="side-info-label">Entregas</span>
        <v-date-picker class="mb-0" v-model="dtPrevista" no-title scrollable :events="eventosReactive" reactive
                       color="#2BC1B6" />
        <v-fade-transition>
            <v-btn class="btn-limpar" v-if="dtPrevista" color="#2BC1B6" outlined @click="limparFiltroData" >
                Limpar Filtro
            </v-btn>
        </v-fade-transition>
<!-- Alerts das datas -->
        <v-item-group color="primary" v-model="entregaSelecionada" active-class="" >
<!-- Entregas atrasadas -->
        <span class="data-label-side-info">Entregas atrasadas</span>
            <v-item v-for="(dias, key, index) in entregas.atrasados" :key="index" v-slot="{ active, toggle }">
                <span @click="() => { toggle()
                                      loadPedido(dias.dt_prevista)}">
                    <v-alert class="d-flex flex-column justify-space-around px-0 clickable" colored-border dense
                             v-ripple border="left" color="#FF5252"
                             :style="applyStyleAlert(active)">
                        <v-row class="full-width flex-nowrap">
                            <v-col cols="8" class="pa-0 pl-3">
                                    <span class="alert-data align-self-center"
                                          :style="active ? 'color: #2BC1B6;' : ''">
                                        {{ dias.ds_dia_semana + ' - ' + formataData(dias.dt_prevista, 'DD/MM') }}
                                    </span>
                            </v-col>
                            <v-col cols="4" class="pa-0 d-flex align-self-center justify-end">
                                    <span class="alert-qtd"
                                    :style="active ? 'color: #2BC1B6;' : ''">
                                        {{ dias.nr_pedidos }}
                                    </span>
                            </v-col>
                        </v-row>
                    </v-alert>
                </span>
            </v-item>
<!-- Entregas para hoje -->
        <span class="data-label-side-info">Entregas para hoje</span>
        <v-item v-for="(dias, key, index) in entregas.hoje" :key="index" v-slot="{ active, toggle }">
            <span @click="() => { toggle()
                                  loadPedido(dias.dt_prevista)}">
                <v-alert class="d-flex flex-column justify-space-around px-0 clickable" colored-border dense
                         v-ripple border="left" color="#F5B800"
                             :style="applyStyleAlert(active)">
                    <v-row class="full-width flex-nowrap">
                        <v-col cols="8" class="pa-0 pl-3">
                                <span class="alert-data align-self-center"
                                          :style="active ? 'color: #2BC1B6;' : ''">
                                    {{ dias.ds_dia_semana + ' - ' + formataData(dias.dt_prevista, 'DD/MM') }}
                                </span>
                        </v-col>
                        <v-col cols="4" class="pa-0 d-flex align-self-center justify-end">
                                <span class="alert-qtd"
                                    :style="active ? 'color: #2BC1B6;' : ''">
                                    {{ dias.nr_pedidos }}
                                </span>
                        </v-col>
                    </v-row>
                </v-alert>
            </span>
        </v-item>
<!-- Entregas futuras -->
        <span class="data-label-side-info">Entregas futuras</span>
        <v-item v-for="(dias, key, index) in entregas.futuro" :key="index" v-slot="{ active, toggle }">
            <span @click="() => { toggle()
                                  loadPedido(dias.dt_prevista)}">
                <v-alert class="d-flex flex-column justify-space-around px-0 clickable" colored-border dense
                         v-ripple border="left" color="#F2F5F3"
                             :style="applyStyleAlert(active)">
                    <v-row class="full-width flex-nowrap">
                        <v-col cols="8" class="pa-0 pl-3">
                                <span class="alert-data align-self-center"
                                          :style="active ? 'color: #2BC1B6;' : ''">
                                    {{ dias.ds_dia_semana + ' - ' + formataData(dias.dt_prevista, 'DD/MM') }}
                                </span>
                        </v-col>
                        <v-col cols="4" class="pa-0 d-flex align-self-center justify-end">
                                <span class="alert-qtd"
                                    :style="active ? 'color: #2BC1B6;' : ''">
                                    {{ dias.nr_pedidos }}
                                </span>
                        </v-col>
                    </v-row>
                </v-alert>
            </span>
        </v-item>
    </v-item-group>
    </v-sheet>
</template>
<script>
import * as moment from 'moment';
import {URLS} from '@/modules/pedidosRacao/resources';
import Vue from 'vue';

export default {
    name: 'entregas-pedido',
    data: ()=> ({
        entregas: {
            atrasados: [],
            hoje: [],
            futuro: [],
        },
        eventos: {},
        loading: false,
        entregaSelecionada: undefined,
    }),
    computed: {
        eventosReactive() {
            return this.eventos;
        },
        dtPrevista: {
            get() { return this.dtPrevistaProp },
            set(v) { this.$emit('setarDtPrevista', v) }
        }
    },
    watch: {
        dtPrevistaProp(dataPrevista) {
            let endpoint = null
            if (dataPrevista) {
                this.entregaSelecionada = [...this.entregas.atrasados, ...this.entregas.hoje, ...this.entregas.futuro]
                                .findIndex(entrega => entrega.dt_prevista.startsWith(dataPrevista))
                this.dtPrevista = this.formataData(dataPrevista, 'YYYY-MM-DD')
                endpoint = moment(this.dtPrevista).isBefore(moment().add(-1,'days')) ?
                                 URLS.ATRASADOS : URLS.CONFIRMADOS
            } else {
                this.limparFiltroData()
            }

            this.$emit('loadPedido', {endpoint, blLimparFiltros: !dataPrevista });
        }
    },
    methods: {
        applyStyleAlert(active) {
            if (this.entregaSelecionada !== undefined)
                return active ? 'background: #DBDBDB;' : 'background: #FAFAFA;'
        },
        loadEntregas() {
            this.loading = true;

            this.$axios
                .get(
                  process.env.VUE_APP_URL_API + URLS.ENTREGAS
                )
                .then(res => {
                    if (!res.data[0]) return
                    this.listaDados = [];
                    if (!res.data[0].data) return

                    this.entregas = res.data[0].data;
                    this.separaDatas(this.entregas);
                })
                .catch(error => {
                  this.$store.commit("setSnack", { type: "error", msg: error });
                })
                .finally(() => {
                    this.loading = false;
                })
        },
        separaDatas(entrega){
            entrega.atrasados.forEach(v => {
                const data = this.formataData(v.dt_prevista, 'YYYY-MM-DD');
                Vue.set(this.eventos, data, v.st_cor);
            });
            entrega.hoje.forEach(v => {
                const data = this.formataData(v.dt_prevista, 'YYYY-MM-DD');
                Vue.set(this.eventos, data, v.st_cor);
            });
            entrega.futuro.forEach(v => {
                const data = this.formataData(v.dt_prevista, 'YYYY-MM-DD');
                Vue.set(this.eventos, data, v.st_cor);
            });
        },
        formataData(date, formatoSaida) {
            const parsedDate = moment(date);
            if (!parsedDate.isValid()) return "";
            return parsedDate.format(formatoSaida);
        },
        loadPedido(dataPrevista) {
            this.$vuetify.goTo(0, {
                duration: 800,
                offset: 0,
                easing: 'easeInOutCubic'
            })

            if (this.entregaSelecionada === undefined)
                this.limparFiltroData()
            else
                this.dtPrevista = dataPrevista.substr(0, 10)
        },
        limparFiltroData() {
            this.dtPrevista = null
            this.entregaSelecionada = undefined
        },
    },
    props: {
        dtPrevistaProp: {
            type: String,
            default: ''
        }
    },
    created() {
        this.loadEntregas();
    }
}
</script>
<style lang="scss" scoped>
@import "src/modules/pedidosRacao/sass/variables";

.sideInfo {
  min-width: 310px;
  z-index: 2;
  box-shadow: -4px 4px 16px $gray-300;
}

.side-info-label {
  font: normal normal bold 16px/21px Roboto;
  letter-spacing: 0;
  color: $gray-200;
  text-transform: uppercase;
  opacity: 1;
}

.data-label-side-info {
  font: normal normal normal 12px/16px Roboto;
  letter-spacing: 0;
  color: $gray-100;
  opacity: 0.7;
  display: block;
}

.alert-data {
  font: normal normal normal 12px/16px Roboto;
  letter-spacing: 0px;
  color: $gray-100;
  opacity: 0.8;
  margin-left: 16px;
  text-transform: capitalize;
}

.alert-qtd {
  font: normal normal bold 16px/21px Roboto;
  letter-spacing: 0px;
  color: $gray-100;
  opacity: 0.8;
  margin-right: 0px;
}

.v-alert {
  background: $gray-600;
}

.btn-limpar {
  margin-top: -26px;
  margin-bottom: 12px;
  background: white;
}

.clickable:hover {
  cursor: pointer;
  user-select: none;
}

.entrega-selecionada {
  background: #b11616;
  border: #b11616 2px solid;
  box-shadow: #b11616 2px 2px;
}

</style>